// This function sorts an array of strings by the number of occurrences of each string.
export function sortByMostOccurrences(arr: string[]): string[] {
  // Step 1: Count the occurrences of each element
  const counts: { [key: string]: number } = {};
  arr.forEach((element) => {
    counts[element] = (counts[element] || 0) + 1;
  });

  // Step 2: Sort the array using the custom comparison function
  // The sort function compares elements based on their counts
  arr.sort((a, b) => {
    const countA = counts[a] ?? 0;
    const countB = counts[b] ?? 0;

    // Primary sort: by count in descending order (most frequent first)
    if (countA > countB) {
      return -1; // a comes before b
    }
    if (countA < countB) {
      return 1; // a comes after b
    }

    // Secondary sort (optional but recommended):
    // If counts are equal, sort alphabetically for consistent results
    // (Array.prototype.sort() stability is not guaranteed across browsers/engines for equal elements)
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0; // elements are equal
  });
  return arr;
}
